export const usersRouteNames = {
  RegisterExample: 'users/register-example',
  Register: 'users/register',
  SignIn: 'users/sign-in',
  ForgotPassword: 'users/forgot-password',
  ResetPassword: 'users/reset-password'
}
